
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-to-make-a-photo-book",
      function () {
        return require("private-next-pages/how-to-make-a-photo-book.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/how-to-make-a-photo-book"])
      });
    }
  